export default {
  'creativeVideo.filter.status.all': 'All statuses',
  'creativeVideo.filter.status.running': 'Generating',
  'creativeVideo.filter.status.success': 'Succeeded',
  'creativeVideo.filter.status.fail': 'Failed',
  'creativeVideo.empty': 'No videos yet',
  'creativeVideo.loadFailed': 'Failed to load videos',
  'creativeVideo.loadingMore': 'Loading more…',
  'creativeVideo.noMore': 'No more items',
  'creativeVideo.download': 'Download',
  'creativeVideo.recreate': 'Create again',
  'creativeVideo.downloadFailed': 'Download failed',
  'creativeVideo.delete': 'Delete',
  'creativeVideo.deleteSuccess': 'Deleted successfully',
  'creativeVideo.deleteFailed': 'Delete failed. Please try again.',
  'creativeVideo.noPreview': 'No video available for preview',
  'creativeVideo.copyPromptSuccess': 'Copied successfully',
  'creativeVideo.copyPromptFailed': 'Copy failed',
  'creativeVideo.meta.refImage': 'Reference image',
  'creativeVideo.meta.refVideo': 'Reference video',
  'creativeVideo.meta.firstFrame': 'First frame',
  'creativeVideo.meta.lastFrame': 'Last frame',
};
